import { render } from "./LanguageEditing.vue?vue&type=template&id=11e0c07f"
import script from "./LanguageEditing.vue?vue&type=script&lang=js"
export * from "./LanguageEditing.vue?vue&type=script&lang=js"
script.render = render

export default script